
export enum Extension {
    JPG = 'jpg',
    JPEG = 'jpeg',
    PNG = 'png',
    GIF = 'gif',
    SVG = 'svg',
    MP4 = 'mp4',
    MOV = 'mov',
    PDF = 'pdf',
    DOC = 'doc',
    DOCX = 'docx',
    PPT = 'ppt',
    PPTX = 'pptx',
    XLS = 'xls',
    XLSX = 'xlsx',
    CSV = 'csv',
    MP3 = 'mp3',
    WAV = 'wav',
    OTHER = 'other'
}